<template>
  <div>
    <v-container
      fluid
      :class="almost_mobile ? 'pt-16 stycard' : 'pt-16 px-10 stycard'"
      style="min-height: 100vh"
    >
      <!-- <div v-show="almost_mobile" style="margin-top: 15%"></div> -->
      <h3 class="pb-2 pt-3 pl-2" style="color: #00a99d; font-size: 25px">
        iClaim
      </h3>

      <div style="margin-top: 20px"></div>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        xl="12"
        class="mb-3"
        style="height: 90vh"
        v-if="isDisplay == 'true'"
      >
        <!-- <iframe
          :src="path"
          title="description"
          style="height: 100%; width: 100%"
          allow="camera *; microphone; display-capture"
          frameBorder="0"
          type="application/pdf"
          sandbox="allow-same-origin allow-scripts"
        ></iframe> -->
        <vue-friendly-iframe 
          ref="iframeEl"  
          :src="path"  
          frameborder="0" 
          gesture="media" 
          style="height: 100%; width: 100%"
          allow="encrypted-media camera *; microphone; display-capture" 
          sandbox="allow-same-origin allow-scripts">
        </vue-friendly-iframe>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        xl="12"
        class="mb-3 d-flex flex-column justify-center align-center bg-D5EEED"
        style="height: 82vh"
        v-else
      >
        <!-- <span class="font-48">iClaim</span> -->
        <span class="font-48">หากต้องการใช้บริการระบบ กรุณาติดต่อเจ้าหน้าที่ info@dhi.co.th</span>

      </v-col>
    </v-container>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      shared_token: "",
      path: "https://iclaim.inet.co.th/hospital/",
      isDisplay: process.env.VUE_APP_ICLAIM,
      // isDisplay: true
    };
  },
  async created() {
    // this.$store.dispatch("getSharedToken");
    this.getPath();
  },
  computed: {
    // ...mapGetters({
    //   // permiss: "permissionsGetter" || {},
    //   path: "getPath" || "",
    // }),
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    async getPath() {
      try {
        let one_access_token = ''
        await this.axios.get(process.env.VUE_APP_BACKEND_URL + `/authorization_v2/v1/getCacheOneAuthorization`)
        .then((res) => {
          if(res.data.result == 'success') {
            one_access_token = res.data.data.one_access_token 
          }
        })
        await this.axios
          .get(`https://one.th/api/v2/service/shared-token`, {
            headers: {
              Authorization: `Bearer ${one_access_token}`,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            let shared_token = response.data.data.shared_token;
            this.path =`https://iclaim.inet.co.th/hospital/?shared_token=${shared_token}`
          });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style>
.stycard {
  /* bg */
  position: absolute;
  /* white */
  background: #fbfffe;
  border-radius: 80px 0px 0px 0px;
}
</style>